import React, { FC, useEffect } from 'react'
import { IVendorsLeadIntakeModel } from './model/VendorsLeadIntakeModel'
import { observer } from 'mobx-react'
import { FormattedMessage, useIntl } from 'react-intl'

interface ISecondIntakeStep {
    model: IVendorsLeadIntakeModel
}

const SecondIntakeStep: FC<ISecondIntakeStep> = observer(({ model }) => {
  const intl = useIntl()

  const scrollToTop = () => window.scrollTo({ top: 0 })

  // Category-specific label (e.g. intake.cafe.forms.need_title) with fallback to generic intake.forms.*
  const formMessageId = (field: string) => {
    const categoryId = `${model.categoryI18NPrefix}.forms.${field}`
    return intl.messages[categoryId] ? categoryId : `intake.forms.${field}`
  }

  const handleClick = () => {
    if (model.orderInfo.wishes.length > 0) {
      model.setCurrentStep(model.currentStep + 1)
    } else {
      model.setIsInputEmpty(true)
    }
  }

  useEffect(() => {
    if (model.isInputEmpty) {
      scrollToTop()
    }
  }, [model.isInputEmpty])

  return (
        <div className='second_step w-100 p-3'>
            <div className='w-100 intake_block'>
                <div className='d-flex justify-content-start align-items-center gap-1'>
                  <FormattedMessage id='back'>
                    {text => <span className='back_link d-flex align-items-center' onClick={() => model.setCurrentStep(model.currentStep - 1)}>{text}</span>}
                  </FormattedMessage>
                </div>
                <h2 className='my-3'>
                    <FormattedMessage id={formMessageId('need_title')} />
                    <span className='important'>*</span>
                </h2>
                <textarea
                    value={model.orderInfo.wishes}
                    onChange={(e) => model.setOrderWishes(e.target.value)}
                    onClick={() => model.setIsInputEmpty(false)}
                    placeholder={intl.formatMessage({ id: formMessageId('need_placeholder') })}
                    name="wishes_field"
                    className={model.isInputEmpty ? 'error' : ''}
                    id="wishes_field" />
            </div>
            <div className='w-100 intake_block'>
                <h2 className='mb-3'>
                    <FormattedMessage id={formMessageId('deadline_title')} />
                </h2>
                <input
                    value={model.orderInfo.deadlines}
                    onChange={(e) => model.setOrderDeadlines(e.target.value)}
                    type='text'
                    placeholder={intl.formatMessage({ id: formMessageId('deadline_placeholder') })}
                    name="deadlines_field"
                    id="deadlines_field" />
            </div>
            <div className='w-100 intake_block'>
                <h2 className='mb-3'>
                    <FormattedMessage id={formMessageId('additional_title')} />
                </h2>
                <input
                    value={model.orderInfo.additional}
                    onChange={(e) => model.setOrderAdditional(e.target.value)}
                    type='text'
                    placeholder={intl.formatMessage({ id: formMessageId('additional_placeholder') })}
                    name="additional_field"
                    id="additional_field" />
            </div>
            <div className='actions intake_block mt-5 w-100 d-flex justify-content-center'>
                <button
                    type='button'
                    className='submit d-flex align-items-center justify-content-center'
                    onClick={handleClick} disabled={model.isInputEmpty}
                >
                    <FormattedMessage id='simple_event.next' />
                </button>
            </div>
        </div>
  )
})

export default SecondIntakeStep
